// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3uJJw","name":"ConsentHeader_name__22ACm","birthday":"ConsentHeader_birthday__3hXy5","skeleton":"ConsentHeader_skeleton__NHsvh"};